module.exports = __webpack_public_path__ + "img/aeo_cert.0ce69f4f.png";